import { folderSteps } from "constants/common";
import documentTypeIds from "constants/documentTypeIds";

const exp = (documentTypeId, showScoring, showContractGeneration, isImage, sessionId) => {
  const isFacilityApproval = documentTypeId === documentTypeIds.FacilityApproval;
  const hasRightToViewScoringPage = showScoring === true;
  const enableAdvancedContractGeneration = showContractGeneration === true;

  const steps = [
    {
      id: folderSteps.generalDataStep.id,
      title: "Folder.Step.GeneralData",
      route: `/folders/{id.documentId}/{id.siteId}/generalData`,
      completed: false,
      disabled: false,
      error: false,
      visible: () => {
        return true;
      }
    },
    {
      id: folderSteps.exposureStep.id,
      title: "Folder.Step.Exposure",
      route: `/folders/{id.documentId}/{id.siteId}/exposure`,
      completed: false,
      disabled: false,
      error: false,
      visible: () => {
        return true;
      }
    },
    isImage && sessionId
      ? {
          id: folderSteps.scoringStep.id,
          title: "Folder.Step.Scoring",
          route: `/folders/{id.documentId}/{id.siteId}/${sessionId}/historyscoringsession`,
          completed: false,
          disabled: false,
          error: false,
          visible: () => {
            return hasRightToViewScoringPage;
          }
        }
      : {
          id: folderSteps.scoringStep.id,
          title: "Folder.Step.Scoring",
          route: `/folders/{id.documentId}/{id.siteId}/scoring`,
          completed: false,
          disabled: false,
          error: isImage,
          visible: () => {
            return hasRightToViewScoringPage;
          }
        },
    {
      id: folderSteps.decisionStep.id,
      title: "Folder.Step.Decision",
      route: `/folders/{id.documentId}/{id.siteId}/decision`,
      completed: false,
      disabled: false,
      error: false,
      visible: () => {
        return true;
      }
    },
    isFacilityApproval
      ? {
          id: folderSteps.fourthStep.id,
          title: "Folder.Step.FacilityFrameConfiguration",
          route: `/folders/{id.documentId}/{id.siteId}/facilityConfiguration`,
          completed: true,
          disabled: false,
          error: false,
          visible: () => {
            return true;
          }
        }
      : {
          id: folderSteps.fourthStep.id,
          title: "Folder.Step.ContractGeneration",
          route: `/folders/{id.documentId}/{id.siteId}/contractgeneration`,
          completed: true,
          disabled: false,
          error: false,
          visible: () => {
            return enableAdvancedContractGeneration;
          }
        }
  ];
  return steps;
};

export default exp;
